import React, { Component } from 'react';
import config from 'react-global-configuration';

import Topo from '../Layout/Topo';
import RequestApi from '../Miscelania/RequestApi';
import Overlay from '../Miscelania/Overlay';
import CalendarDay from './Elements/CalendarDay';
import getLocale from '../../i18n/getLocale';

class Calendar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      dados: []
    };
    this.calendario = this.calendario.bind(this);
    this.proximo = this.proximo.bind(this);
    this.anterior = this.anterior.bind(this);

    this.locale = getLocale();
  }

  componentDidMount () {
    this.refs.request_api.verifyPermission();
    var now = new Date();
    var mes = (now.getMonth()) + 1;
    var ano = now.getFullYear();
    var referencia = mes + '/' + ano;
    this.calendario(referencia);
  }

  calendario(referencia) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    var url = config.get('api') + '/calendario/' + referencia;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({
            dados: responseJson.data,
            anterior: responseJson.datas.anterior,
            atual: responseJson.datas.atual,
            proximo: responseJson.datas.proximo,
            overlay: {
              message: '',
              type: '',
              status: 'closed',        
            },      
          });
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  proximo() {
    this.calendario(this.state.proximo);
  }

  anterior() {
    this.calendario(this.state.anterior);
  }


  render() {
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <div className="row">
        <div className="col-md-4">
          <button className="btn btn-primary" onClick={this.anterior}><i className="fa fa-fw fa-chevron-left"></i> <span className="hidden-xs">{this.state.anterior}</span></button>
        </div>
        <div className="col-md-4">
          <h3 className="page-title text-center">{this.state.atual}</h3>
        </div>
        <div className="col-md-4 text-right">
          <button className="btn btn-primary" onClick={this.proximo}><span className="hidden-xs">{this.state.proximo}</span> <i className="fa fa-fw fa-chevron-right"></i></button>
        </div>
      </div>
      <hr/>
      <div className="table-responsive">
        <table className="table calendario">
          <thead>
            <tr>
              <th>{this.locale.Calendario.Calendario.tabela.Domingo}</th>
              <th>{this.locale.Calendario.Calendario.tabela.SegundaFeira}</th>
              <th>{this.locale.Calendario.Calendario.tabela.TercaFeira}</th>
              <th>{this.locale.Calendario.Calendario.tabela.QuartaFeira}</th>
              <th>{this.locale.Calendario.Calendario.tabela.QuintaFeira}</th>
              <th>{this.locale.Calendario.Calendario.tabela.SextaFeira}</th>
              <th>{this.locale.Calendario.Calendario.tabela.Sabado}</th>
            </tr>             
          </thead>
          <tbody>
          {this.state.dados.map(function(semana, linha) {
            return (
              <CalendarDay semana={semana} />
            );
          })}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/Components/Calendar/Calendar.js